/* eslint-disable import/prefer-default-export */
import { defineStore } from 'pinia';
import { useTrackingStore } from '@/stores/tracking/trackingStore';
import useApiHelpers from '@/composables/api/helpers';

const { postRequest } = useApiHelpers();

export const useRouteStore = defineStore({
  id: 'route',
  state: () => ({
    history: JSON.parse(sessionStorage.getItem('routeHistory')) || [],
  }),
  actions: {
    push(to) {
      this.history.push(to.fullPath);
      sessionStorage.setItem('routeHistory', JSON.stringify(this.history));
    },
    submitError() {
      const trackingStore = useTrackingStore();
      postRequest('/logging/log', {
        data: {
          event_name: 'ORDER_JOURNEY_ERROR',
          route: this.history,
          actions: trackingStore.getActions,
          customerKey: trackingStore.getCustomerKey,
          orderKey: trackingStore.getOrderKey,
          customProperties: trackingStore.getCustomProperties,
        },
      });
    },

  },
  getters: {
    getHistory: (state) => state.history,
  },
});
